import React, { useState } from 'react';
import s from './frame.module.css';
import PortfolioSubTab from './portfolio_tab_subtab';
export default function PortfolioTabFrame(){
 const [selected,setSelected]=useState(0);
 return <div className={s.Tabs}><div className={s.TabList} role="group" aria-label="기술 분류">{['#백엔드','#프론트엔드','#인프라','#키워드'].map((title,index)=><button key={title} className={s.Button} type="button" aria-pressed={selected===index} onClick={()=>setSelected(index)}>{title}</button>)}</div><PortfolioSubTab key={selected} selected={selected}/></div>;
}
